import { render, staticRenderFns } from "./InsightsCard.vue?vue&type=template&id=f44553ee&scoped=true"
import script from "./InsightsCard.vue?vue&type=script&lang=ts"
export * from "./InsightsCard.vue?vue&type=script&lang=ts"
import style0 from "./InsightsCard.vue?vue&type=style&index=0&id=f44553ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44553ee",
  null
  
)

export default component.exports